import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CompanyService, ContactService } from '../../../../_services';
import { Transition } from '@uirouter/angular';
import {
    Contact,
    Company,
    TrainingSessionCompany,
} from '../../../../_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToasterService } from '../../../_shared/toaster/toaster.service';

@Component({
    selector: 'contacts-detail',
    templateUrl: './detail.component.html',
    styleUrls: [],
})
export class ContactDetailComponent implements OnInit {
    @Input() contact: Contact;
    @Input() company: TrainingSessionCompany;
    @Input() contactType: string;
    @Output() getContact: EventEmitter<any> = new EventEmitter<Contact>();

    account: any;
    currentContact: any;
    companySelected: boolean;

    deleteModalRef: any;

    constructor(
        private contactService: ContactService,
        private companyService: CompanyService,
        private modalService: NgbModal,
        private trans: Transition,
        private toasterService: ToasterService
    ) {}

    ngOnInit(): void {
        if (
            this.contactType !== 'create' &&
            this.contactType !== 'createInModal'
        ) {
            this.contactType = 'update';
        }
        if (this.contactType === 'update') {
            this.load(this.trans.params()['id']);
        } else {
            this.currentContact = {
                type: 'CONTACT',
                version: '',
                job: '',
                initialized: true,
                deleted: false,
                company: [],
                contactExtended: {
                    mailToContactOnly: false,
                },
                emailingMode: 'CONTACT_AND_STUDENTS',
            };
        }
    }

    load(id: number) {
        this.contactService.getContactById(id).subscribe((contact) => {
            if (!contact.contactExtended) {
                contact.contactExtended = {
                    mailToContactOnly: false,
                };
            }
            this.currentContact = contact;
        });
    }

    searchCompanies(keyword: string) {
        return this.companyService.search(keyword);
    }

    saveContact() {
        const contact = JSON.parse(JSON.stringify(this.currentContact));

        if (this.contactType == 'createInModal') {
            this.companyService
                .findById(this.company.companyId)
                .subscribe((res) => {
                    contact.company[0] = res;
                    this.contactService
                        .create(contact)
                        .subscribe((response) => {
                            if (response !== null) {
                                this.getContact.emit(response);
                            }
                        });
                });
        } else if (this.contactType == 'create') {
            this.contactService.create(contact).subscribe((response) => {
                if (response !== null) {
                    this.isSuccessful(response.id);
                }
            });
        } else {
            this.contactService.update(contact).subscribe((response) => {
                if (response !== null) {
                    this.isSuccessful(response.id);
                }
            });
        }
    }

    myListFormatter(data: any): string {
        let html = '';
        html += data.name ? `<span><strong>${data.name}</strong></span>` : '';
        html += data.id ? `<span> (${data.id})</span>` : '';
        html += data.city ? `<span> - ${data.city}</span>` : '';

        return html;
    }

    changeCompany(newVal) {
        this.companySelected = true;
        if (
            newVal !== null &&
            typeof newVal !== 'undefined' &&
            newVal.id !== null &&
            typeof newVal.id !== 'undefined'
        ) {
            this.currentContact.company[0].name = newVal.name;
        }
    }

    removeContact() {
        this.currentContact.deleted = true;
        this.contactService.update(this.currentContact).subscribe(() => {
            this.isSuccessful();
            this.closeModal();
            window.location.href = '#/contacts';
        });
    }

    showModal(deleteModal) {
        event.stopPropagation();
        this.deleteModalRef = this.modalService.open(deleteModal);
    }

    closeModal() {
        this.deleteModalRef.close();
    }

    focusOnCompanyAutocomplete() {
        this.companySelected = false;
        this.currentContact.company[0] = null;
    }

    private isSuccessful(id?: number) {
        this.toasterService.success();
        window.setTimeout(() => {
            if (typeof id !== 'undefined') {
                window.location.href = '#/contacts/' + id;
            }
        }, 1542);
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/directory/contact/detail/detail.component.ts